import React, { useEffect, useState } from 'react';
import CartIcon from '../../icons/cart';
import { Link } from 'react-router-dom';
import AddToCart from '../AddToCart';
import BookCarousel from '../BookCarousel';


export default function BookPage() {

  document.title = `Bread and Water by Eileen Myles | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `First published by Hanuman Books in 1986, Bread and Water is the debut short story collection by the renowned poet Eileen Myles.`);

  return (<div className='newPageContainer'>
    <div className='productContainer'>
      <div className='productImage_container  '>
        <div className='productCarousel'>
          <BookCarousel images={['../../Series-One/B-w_Back.png', '../../Series-One/B-w_Side.png', '../../Series-One/B-w_Front.png']} start={1} />
        </div>
      </div>
      <div className='productInfo_container'>
        <div className='productInfo_inner'>
          <div className='productInfo'>
            <h1 className='productTitle'>Bread and Water</h1>
            <div className='productAuthor'>Eileen Myles</div>
          </div>
          <div className='productBuyControls'>
            <AddToCart context={'product'} id={'9798989378043'} />
            <div className='productPrice'>$15.99 USD</div>
          </div>

          <div className='productDescription'><em>Bread and Water</em> offers a look at cult New York poet Eileen Myles’ trademark style in formation: encapsulating the drifts and drags of a young working-class artist seeking out love, community, adventure; finding the joys of expression, and therein, undoing.
          </div>
          <div className='productDescription'>
            <p>The poet, novelist and former presidential candidate <strong>Eileen Myles</strong> moved to New York in 1974 and quickly became involved in a vital circle of artists based around the St. Marks’ Poetry Project. Myles’ work is widely recognized as an exemplar of first-person writing, owing to their eye for the irreverent power of the slapdash and mundane, how a swab of peanut butter or coffee cup rings evoke keen truths of being and appetite. Myles is the author of queer canon texts <em>Chelsea Girls</em> (1994) and <em>Cool for You</em> (2000), and recently, the literary anthology, <em>Pathetic Literature</em> (2022).</p>
          </div>
          <div className='productMetadata'>
            <div>Series I</div>
            <div>Spring 2026</div>
            <div>ISBN 9798989378043</div>
            <div>4.125 x 2.75 inches</div>
            <div>198 Pages</div>
          </div>
        </div>
      </div>
    </div>
  </div>)

}